import React, { FC, useMemo } from 'react';

// components
import { SearchableSelectType } from '../../../components/inputs/searchableSelect';
import AampeCreateSelectDropdown from '../../../components/shared/AampeCreateSelectDropdown/AampeCreateSelectDropdown';

// helpers
import { getTimeZoneOptions } from '../../../helpers/timezoneHelper';

interface TimeZoneDropdownProps {
    disabled?: boolean;
    onChange: (value: SearchableSelectType) => void;
    value: string;
}

const TimeZoneDropdown: FC<TimeZoneDropdownProps> = ({
    disabled,
    onChange,
    value,
}) => {
    const selectOptions = useMemo<SearchableSelectType[]>(
        getTimeZoneOptions,
        [],
    );

    const selectionOption: SearchableSelectType | undefined = useMemo(
        () => selectOptions.find((item) => item.value === value),
        [value, selectOptions],
    );

    return (
        <AampeCreateSelectDropdown
            options={selectOptions}
            name={'timezone_select'}
            onChange={(key, value) => onChange(value as SearchableSelectType)}
            placeholder={'Start typing city or country...'}
            value={selectionOption}
            isDisabled={disabled}
            isClearable={false}
        />
    );
};

export default TimeZoneDropdown;
